import { FC } from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  Box,
  Code,
} from '@wegroup/design-system';
import { ErrorResponse } from '../../../../../../../../../types/API';
import { useTranslation } from 'react-i18next';

interface Props {
  error: Error;
}

export const AnvaErrorAlert: FC<Props> = ({ error }) => {
  const { t } = useTranslation();

  const errorObj = error?.message
    ? (JSON.parse(error?.message) as ErrorResponse)
    : undefined;

  return (
    <Alert
      status="error"
      mb="3"
      flexDirection="column"
      alignItems="stretch"
      gap="3"
    >
      <Box display="flex">
        <AlertIcon alignSelf="flex-start" />
        <AlertTitle
          display="flex"
          flexDirection="column"
          gap="3"
          alignItems="stretch"
        >
          <p>{t('Something went wrong')}</p>
        </AlertTitle>
      </Box>
      {errorObj?.detail && (
        <Code
          p="3"
          overflow="auto"
          maxW="full"
          bg="white"
          border="1px"
          borderColor="gray.50"
          textAlign="left"
          whiteSpace="pre"
        >
          {(JSON.stringify(errorObj?.detail, null, 2) || '')
            .replace(/\\\\n/g, '\n')
            .replace(/\\n/g, '\n')}
        </Code>
      )}
    </Alert>
  );
};
